/* eslint-disable prettier/prettier */
// Auto-generated on 2025-09-11 13:32:57 by generate_notification_constants.go

export const WebSocketMessageType = {
  UPLOAD_ORG_DATA: 'UPLOAD_ORG_DATA',
  UPLOAD_MARKET_DATA: 'UPLOAD_MARKET_DATA',
  GENERAL: 'GENERAL'
}

